import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsCompanyProfile from './SettingsCompanyProfile';

function CompanyProfilePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Company Profile"
        subtitle="Company details and branding"
        backTo="/settings-landing"
        backLabel="Settings"
        sticky
      />
      <div className="p-6">
        <SettingsCompanyProfile />
      </div>
    </div>
  );
}

export default CompanyProfilePage;
